// src/components/VyjezdyForm.jsx
import React, { useCallback, useMemo, useState, useEffect, useRef} from "react";
import { useFormData } from "../context/FormDataContext";
import { API_BASE, getToken, logout as authLogout } from "../auth/authClient";
import { useAutoSaveZakazka } from "../hooks/useAutoSaveZakazka";
import { apiFetch } from "../auth/authClient";

import FotogalerieZakazky from "./FotogalerieZakazky";
import { extractOrderIdFromResponse, getOrderId } from "../lib/orderId";

import VyjezdyModalKrok1 from "./VyjezdyModalKrok1";





// === AUTO FIX: helper to set input value by DOM id (prevents ReferenceError) ===
function _setInputValueById(id, value) {
  try {
    if (!id) return;
    const el = document.getElementById(String(id));
    if (!el) return;
    el.value = value == null ? "" : String(value);
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  } catch (e) {}
}

// === AUTO FIX: _todayISO helper (YYYY-MM-DD, timezone-safe) ===
function _todayISO() {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
}
// === /AUTO FIX ===

// === /AUTO FIX ===


// === AUTO: token helper (VyjezdyForm) ===

// === AUTO: safe error reader (Response | object | string) ===
async function safeErrText(r) {
  try {
    if (!r) return "";
    if (typeof r === "string") return r;
    if (typeof r.text === "function") return await r.text();
    if (typeof r.json === "function") {
      const j = await r.json();
      return (typeof j === "string") ? j : JSON.stringify(j);
    }
    return JSON.stringify(r);
  } catch (e) {
    try { return String(e?.message || e); } catch (_) { return ""; }
  }
}
// === /AUTO ===

function getTokenLS() {
  try {
    return String(getToken() || "").trim();
  } catch {
    return "";
  }
}


// === AUTO helper: safe read text from fetch/apiFetch response ===
async function safeReadText(r) {
  try {
    if (!r) return "";
    // real fetch Response
    if (typeof r === "object" && typeof r.text === "function") return await r.text();
    // apiFetch might return already parsed data
    if (typeof r === "string") return r;
    if (typeof r === "number" || typeof r === "boolean") return String(r);
    // object / array
    try { return JSON.stringify(r); } catch (_) { return String(r); }
  } catch (e) {
    return String((e && e.message) ? e.message : e);
  }
}
  // === /AUTO helper ===
// === AUTO: blob preview helper (no token in URL) ===
async function fetchImageBlobUrl(path, apiFetchFn) {
  const res = await apiFetchFn(path, { method: "GET" });
  if (!res.ok) {
    const t = await safeReadText(res).catch(() => "");
    throw new Error(`Foto načtení selhalo (${res.status}): ${t || res.statusText}`);
  }
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
// === /AUTO: blob preview helper ===

const cardStyle = { border: "1px solid #333", borderRadius: 12, padding: 12, marginBottom: 12 };
const btnStyle = { padding: "10px 14px", borderRadius: 10, border: "1px solid #444", cursor: "pointer", fontWeight: 900 };
const inputStyle = { width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #444", outline: "none" };
const labelStyle = { fontSize: 13, fontWeight: 800, marginBottom: 6 };

function safeStr(v) {
  return v == null ? "" : String(v);
}

function pick(obj, paths, fallback = "") {
  for (const p of paths) {
    const parts = p.split(".");
    let cur = obj;
    let ok = true;
    for (const k of parts) {
      if (cur && Object.prototype.hasOwnProperty.call(cur, k)) cur = cur[k];
      else {
        ok = false;
        break;
      }
    }
    if (ok && cur != null && String(cur).trim() !== "") return cur;
  }
  return fallback;
}

export default function VyjezdyForm() {
  // (když tady bude >0, ale UI je prázdné, je to čistě render)
  
  
  // === VYJEZDY: UI state pro dropdowny (krok 1) ===
    // === LS helpers (MUST be before useState init) ===
  function lsGet(k, d = "") {
    try { return localStorage.getItem(k) || d; } catch { return d; }
  }
  function persistLS(k, v) {
    try { localStorage.setItem(k, String(v)); } catch {}
  }
  function persistJSON(k, v) {
    try { localStorage.setItem(k, JSON.stringify(v)); } catch {}
  }
  // === /LS helpers ===
    const [vyjezdSpzMode, setVyjezdSpzMode] = useState(lsGet("vyjezd_spz_mode", "select")); // select|custom
  const [vyjezdSpzSelect, setVyjezdSpzSelect] = useState(lsGet("vyjezd_spz_select", ""));
  const [vyjezdSpzCustom, setVyjezdSpzCustom] = useState(lsGet("vyjezd_spz_custom", ""));

  const [vyjezdOdSelect, setVyjezdOdSelect] = useState(lsGet("vyjezd_od_select", ""));
  const [vyjezdOdCustom, setVyjezdOdCustom] = useState(lsGet("vyjezd_od_custom", ""));

  const [vyjezdKamSelect, setVyjezdKamSelect] = useState(lsGet("vyjezd_kam_select", ""));
  const [vyjezdKamCustom, setVyjezdKamCustom] = useState(lsGet("vyjezd_kam_custom", ""));

  const [posadkaSelected, setPosadkaSelected] = useState(() => {
    try {
      const raw = localStorage.getItem("vyjezd_posadka_selected");
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });
  // (moved) persistLS
  // (moved) persistJSON
  // === /VYJEZDY: UI state ===

const [imgCache, setImgCache] = useState({});

  const [vyjezdyModal1Open, setVyjezdyModal1Open] = useState(false);
  const [vyjezdyModal1Default, setVyjezdyModal1Default] = useState(null);
const ctx = useFormData();
  // === AUTO: uložení vybraného výjezdu do formData.vyjezdAuto (pro Vstupní informace) ===
  function applyVyjezdToVstupniInfo(v) {
    try {
      if (!v) return;
      const setFormData = ctx && (ctx.setFormData || ctx._setFormData);
      if (typeof setFormData !== "function") {
        console.warn("VyjezdyForm: setFormData není dostupné v ctx");
        alert("⚠️ Nelze uložit do Vstupních informací (chybí setFormData).");
        return;
      }
      setFormData((prev) => ({
        ...prev,
        vyjezdAuto: {
          id: v.id ?? null,
          datum: v.datum ?? "",
          casOd: v.casOd ?? "",
          casDo: v.casDo ?? "",
          autoSpz: v.autoSpz ?? v.spz ?? "",
          posadka: Array.isArray(v.posadka) ? v.posadka : (typeof v.posadka === "string" ? [v.posadka] : []),
          odkud: v.odkud ?? "",
          kam: v.kam ?? "",
          km: typeof v.km === "number" ? v.km : (Number(v.km) || 0),
            poznamka: v.poznamka ?? "",
            // === data pro auto-vyplnění Vstupních informací ===
            jmenoZesnulehoCele: v.jmenoZesnuleho ?? v.jmenoZesnulehoCele ?? v.jmeno ?? v.zesnuly ?? "",
            jmenoZesnuleho: v.jmenoZesnuleho ?? v.jmeno ?? "",
            prijmeniZesnuleho: v.prijmeniZesnuleho ?? v.prijmeni ?? "",
            datumUmrti: v.datumUmrti ?? "",
            mistoUmrti: v.mistoUmrti ?? "",
            adresaUmrti: v.adresaUmrti ?? v.adresa ?? "",
            updatedAt: v.updatedAt ?? null,
        },
      }));
      alert("✅ Výjezd uložen do Vstupních informací (připraveno k vyplnění).");
    } catch (e) {
      console.error("applyVyjezdToVstupniInfo error:", e);
      alert("❌ Nepodařilo se uložit výjezd do Vstupních informací.");
    }
  }
  // === /AUTO ===

  const { formData, mergeFormData } = ctx;
// ✅ AUTOSAVE
  useAutoSaveZakazka(true, 900);

  const [ocrBusy, setOcrBusy] = useState(false);
  const [ocrError, setOcrError] = useState("");
  const [ocrOk, setOcrOk] = useState("");
  const [ocrFileName, setOcrFileName] = useState("");

  const [galOhled, setGalOhled] = useState([]);
  const [galZesnuly, setGalZesnuly] = useState([]);

  const vyjezdy = formData?.vyjezdy || {};


  // === AUTO VIEW: fallback z vstupniInformace / zesnulaOsoba (backend vrací vyjezdy často prázdné)
  const vst = formData?.vstupniInformace || {};
  const zos = formData?.zesnulaOsoba || {};
  const vyjezdyView = {
    ...(formData?.vyjezdy || {}),
    zesnulyJmeno: String((formData?.vyjezdy?.zesnulyJmeno || vst?.jmenoZesnuleho || zos?.jmeno || "") || ""),
    zesnulyPrijmeni: String((formData?.vyjezdy?.zesnulyPrijmeni || vst?.prijmeniZesnuleho || zos?.prijmeni || "") || ""),
    datumUmrti: String((formData?.vyjezdy?.datumUmrti || vst?.datumUmrti || zos?.datumUmrti || "") || ""),
    casUmrti: String((formData?.vyjezdy?.casUmrti || vst?.casUmrti || "") || ""),
    mistoUmrti: String((formData?.vyjezdy?.mistoUmrti || vst?.mistoUmrti || zos?.mistoUmrti || "") || ""),
    adresaUmrti: String((formData?.vyjezdy?.adresaUmrti || vst?.adresaUmrti || zos?.adresa || "") || ""),
  };
// === AUTO PROPIS: vyjezdy -> zakazka (bez přepisování ruční práce) ===

  useEffect(() => {

    try {

      const vyj = (formData && formData.vyjezdy) ? formData.vyjezdy : {};

      // === NORMALIZACE: zabrání "1 písmeno" + rozbitým hodnotám typu "g,r,s" ===
      const normText = (x) => {
        if (Array.isArray(x)) {
          const arr = x
            .filter(v => v !== null && v !== undefined)
            .map(v => String(v).trim())
            .filter(Boolean);
          const allOneChar = arr.length && arr.every(v => v.length === 1);
          const joined = allOneChar ? arr.join("") : arr.join(" ");
          return joined.replace(/\s+/g, " ").trim();
        }
        return String(x || "")
          .replace(/,/g, "")      // "g,r,s" -> "grs"
          .replace(/\s+/g, " ")
          .trim();
      };

      const celeJmeno = normText(vyj.jmenoZesnuleho || vyj.jmenoZesnulehoCele || vyj.jmeno || vyj.zesnuly || "");
      const parts = celeJmeno ? celeJmeno.split(/\s+/).filter(Boolean) : [];

      const jmeno = normText(vyj.jmeno || (parts[0] || ""));
      const prijmeni = normText(vyj.prijmeni || (parts.length > 1 ? parts.slice(1).join(" ") : ""));

  

      const datumUmrti = String(vyj.datumUmrti || "").trim();

      const mistoUmrti = String(vyj.mistoUmrti || "").trim();

      const adresaUmrti = String(vyj.adresaUmrti || vyj.adresa || "").trim();

  

      const z = formData?.zesnulaOsoba || {};

      const v = formData?.vstupniInformace || {};
        // nepřepisuj ručně vyplněné – doplňuj jen prázdná pole (per-field)
        const payload = {};

        // ZESNULÁ OSOBA
        const zPatch = {};
        if (jmeno && !String(z?.jmeno || "").trim()) zPatch.jmeno = jmeno;
        if (prijmeni && !String(z?.prijmeni || "").trim()) zPatch.prijmeni = prijmeni;
        if (Object.keys(zPatch).length) payload.zesnulaOsoba = { ...(z || {}), ...zPatch };

        // VSTUPNÍ INFORMACE – jméno + údaje úmrtí
        const vPatch = {};
        if (jmeno && !String(v?.jmenoZesnuleho || "").trim()) vPatch.jmenoZesnuleho = jmeno;
        if (prijmeni && !String(v?.prijmeniZesnuleho || "").trim()) vPatch.prijmeniZesnuleho = prijmeni;

        if (datumUmrti && !String(v?.datumUmrti || "").trim()) vPatch.datumUmrti = datumUmrti;
        if (mistoUmrti && !String(v?.mistoUmrti || "").trim()) vPatch.mistoUmrti = mistoUmrti;
        if (adresaUmrti && !String(v?.adresaUmrti || "").trim()) vPatch.adresaUmrti = adresaUmrti;

        if (Object.keys(vPatch).length) payload.vstupniInformace = { ...(v || {}), ...vPatch };

        if (Object.keys(payload).length && typeof mergeFormData === "function") {
          mergeFormData(payload);
        }

    } catch {}

  }, [

    formData?.vyjezdy,

    formData?.zesnulaOsoba,

    formData?.vstupniInformace,

    mergeFormData,

  ]);

  // === /AUTO PROPIS ===


  // ✅ AUTO: jakmile vyplníš místo/adresu úmrtí, předvyplní se 1. převoz (firma -> úmrtí)
  useEffect(() => {
    try {
      const base = "Český Krumlov, Pod Skalkou 525";
      const vi = formData?.vstupniInformace || {};
      const vy = formData?.vyjezdy || {};
      const kam = String(vi?.adresaUmrti || vi?.mistoUmrti || vy?.mistoUmrti || "").trim();
      if (!kam) return;

      const prevozy = Array.isArray(formData?.prevozy) ? formData.prevozy : [];
      const first = (Array.isArray(prevozy) ? prevozy[0] : prevozy) || {};
      const firstKam = String(first.kam || first.toAddress || "").trim();

      // pokud už uživatel převoz vyplnil, nezasahujeme
      if (firstKam) return;

      mergeFormData({
        prevoz: { baseAdresa: base, ckChladAdresa: "Český Krumlov, Hřbitovní 149" },
        prevozy: [
          { ...(first || {}), od: base, kam },
          ...(prevozy.slice(1) || []),
        ],
      });
} catch (e) {}
  }, [formData?.vstupniInformace?.adresaUmrti, formData?.vstupniInformace?.mistoUmrti, formData?.vyjezdy?.mistoUmrti]);

  const vstup = formData?.vstupniInformace || {};
  const zes = formData?.zesnulaOsoba || {};

  // ✅ patch posílá jen partial – deepMerge v kontextu to složí bezpečně
  // ✅ patch posílá jen partial – deepMerge v kontextu to složí bezpečně
  // ✅ + normalizace: zabrání 1 znaku / array hodnotám
  const normVal = (x) => {
    if (Array.isArray(x)) {
      const arr = x
        .filter(v => v !== null && v !== undefined)
        .map(v => String(v).trim())
        .filter(Boolean);
      if (!arr.length) return "";
      const allOneChar = arr.every(v => v.length === 1);
      const joined = allOneChar ? arr.join("") : arr.join(" ");
      return joined.replace(/\s+/g, " ").trim();
    }
    return String(x || "")
      .replace(/,/g, "")      // "g,r,s" -> "grs"
      .replace(/\s+/g, " ")
      .trim();
  };

  const sanitizePartial = (obj) => {
    const o = (obj && typeof obj === "object") ? { ...obj } : {};
    const keys = [
      "jmeno", "prijmeni", "zesnuly",
      "jmenoZesnuleho", "prijmeniZesnuleho", "jmenoZesnulehoCele",
      "mistoUmrti", "adresaUmrti",
      "odkud", "kam",
      "autoSpz", "spz",
      "poznamka"
    ];
    for (const k of keys) {
      if (k in o) o[k] = normVal(o[k]);
    }
    return o;
  };

  const patch = useCallback(
    (key, partialObj) => {
      if (typeof mergeFormData !== "function") return;
      const clean = sanitizePartial(partialObj || {});
      mergeFormData({ [key]: clean });
    },
    [mergeFormData]
  );

  // ✅ Jediná pravda pro orderId ve Výjezdech
  const getEffectiveOrderId = useCallback(() => {
    return String(
      formData?.orderId ||
      formData?.currentOrderId ||
      ctx?.currentOrderId ||
      formData?.zakazkaId ||
      formData?.id ||
      formData?.vyjezd?.orderId ||
      ""
    ).trim();
  }, [formData, ctx?.currentOrderId]);

  // ✅ Zajistí existenci orderId (když není otevřená / založená zakázka)
  const ensureOrderId = useCallback(async () => {
    const existing = getEffectiveOrderId();
    if (existing) return existing;

    const payload = {
      stav: "rozpracovana",
      typ: (ctx?.formData?.kremacePohreb?.typ || "Kremace"),
      datum: (ctx?.formData?.kremacePohreb?.datumObradu || ctx?.formData?.kremacePohreb?.obradDatum || ctx?.formData?.datumObradu || ""),
      vstupniInformace: ctx?.formData?.vstupniInformace || {},
      zesnulaOsoba: ctx?.formData?.zesnulaOsoba || {},
      vypravitel: ctx?.formData?.vypravitel || {},
    };

    const r = await apiFetch("/api/zakazky/create-from-vyjezd", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!r.ok) {
        const t = await __safeReadText(r);
        throw new Error(`create: zakazky/create-from-vyjezd failed (${r.status}): ${t || r.statusText}`);
      }

      const jj = (r && typeof r === "object" && typeof r.json === "function") ? await __safeReadJson(r) : (r || {});
      const newId =
        String(jj?.orderId || jj?.id || jj?.currentOrderId || jj?.activeId || "").trim();

      if (!newId) throw new Error("create: server nevrátil id/orderId");

    try { localStorage.setItem("lastOpenedOrderId", String(newId)); } catch {}
    try { localStorage.setItem("currentOrderId", String(newId)); } catch {}

      if (typeof ctx?.setCurrentOrderId === "function") ctx.setCurrentOrderId(String(newId));
      if (typeof ctx?.updateFormData === "function") {
        ctx.updateFormData({
          currentOrderId: String(newId),
          orderId: String(newId),
          zakazkaId: String(newId),
          id: String(newId),
          meta: {
            ...(((ctx?.formData) && ctx.formData.meta) || {}),
            id: String(newId),
            orderId: String(newId),
            zakazkaId: String(newId),
          },
        });
      }

      if (typeof mergeFormData === "function") {
        mergeFormData({
          vyjezd: { orderId: String(newId), zakazkaId: String(newId), id: String(newId) },
          currentOrderId: String(newId),
          orderId: String(newId),
          zakazkaId: String(newId),
          id: String(newId),
          meta: {
            id: String(newId),
            orderId: String(newId),
            zakazkaId: String(newId),
          },
        });
      }

    return String(newId);
  }, [getEffectiveOrderId, ctx, mergeFormData]);

  // ===== VYJEZDY LIST (array z backendu) =====
  const vyjezdyList = Array.isArray(formData?.vyjezdyList) ? formData.vyjezdyList : [];
  
  // === SAFE READ HELPERS (apiFetch může vrátit Response nebo plain object) ===
  async function __safeReadText(r) {
  try {
    if (r && typeof r === "object" && typeof r.text === "function") return await safeErrText(r);
    if (typeof r === "string") return r;
    if (r === null || r === undefined) return "";
    return JSON.stringify(r);
  } catch (e) {
    return String((e && e.message) ? e.message : e);
  }
}
  async function __safeReadJson(r) {
      try {
        if (r && typeof r === "object" && typeof r.json === "function") return await r.json();
        return (r && typeof r === "object") ? r : {};
      } catch {
        return {};
      }
    }
  // === /SAFE READ HELPERS ===

const loadVyjezdyList = useCallback(async () => {
      const oid = await ensureOrderId(); // zajistí orderId

      const r = await apiFetch(`/api/vyjezdy/list?orderId=${encodeURIComponent(oid)}`, { method: "GET" });

      // apiFetch u nás někdy vrací Response, jindy rovnou JSON objekt
      const isResponse = !!(r && typeof r === "object" && typeof r.json === "function");
      const ok = isResponse ? !!r.ok : (r && r.ok === false ? false : true);

      if (!ok) {
        const status = isResponse ? r.status : 0;
        const t = isResponse ? await __safeReadText(r) : JSON.stringify(r || {});
        throw new Error(`Vyjezdy list failed (${status || "no-status"}): ${t}`);
      }

      const j = isResponse ? await __safeReadJson(r) : (r || {});
      const list = Array.isArray(j?.vyjezdy) ? j.vyjezdy : (Array.isArray(j?.items) ? j.items : []);

      if (typeof mergeFormData === "function") {
        mergeFormData({ vyjezdyList: list });
      }
      return list;
    }, [ensureOrderId, mergeFormData]);

  // Načti list při vstupu do záložky (mount)
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        await loadVyjezdyList();
      } catch (e) {
        console.warn("loadVyjezdyList error:", e);
      }
    })();
    return () => { alive = false; };
  }, []);

  
    // eslint-disable-next-line react-hooks/exhaustive-deps
// ===== /VYJEZDY LIST =====

  // ==========================
  // POJISTOVNY_PREVOZ_V1
  // ==========================
  
  // === VYJEZDY: DROPDOWN OPTIONS (FE-only defaults) ===
  const VYJEZD_SPZ_OPTIONS = [
    "3C0 1234", "4C1 5678", "2C2 9999"
  ];

  const VYJEZD_POSADKA_OPTIONS = [
    "Pavel", "Petra", "Mačková", "Šnoblová", "Novák", "Burka", "Kníža", "Roman", "Opelka"
  ];

  const VYJEZD_MISTA_OD_OPTIONS = [
    "Místo úmrtí (z Vstupní info)",
    "Český Krumlov, Hřbitovní 149 (chladírna)",
    "Nemocnice ČK",
    "Domov seniorů",
    "Jiné…"
  ];

  const VYJEZD_MISTA_KAM_OPTIONS = [
    "Patologie",
    "Český Krumlov, Hřbitovní 149 (chladírna)",
    "Krematorium",
    "Obřadní síň",
    "Hřbitov",
    "Jiné…"
  ];

  // last-used helpers
  // (moved) lsGet
  // (JS v pythonu nevložíme takhle) -> uděláme JS ekvivalent níže
  // === /VYJEZDY: DROPDOWN OPTIONS ===

const POJISTOVNY = [
  { kod: "111", nazev: "VZP (111)" },
  { kod: "201", nazev: "VOZP (201)" },
  { kod: "205", nazev: "ČPZP (205)" },
  { kod: "207", nazev: "OZP (207)" },
  { kod: "209", nazev: "ZPŠ (209)" },
  { kod: "211", nazev: "ZPMV (211)" },
  ];

  const vyjObj = (formData && formData.vyjezdy) ? formData.vyjezdy : {};

  const getRezimLocked = () => {
  try {
    const oid = String(getEffectiveOrderId?.() || "").trim();
    const rez = String(vyjObj?.rezimPrevozu || "").trim();
    // zamykáme až po založení zakázky (existuje orderId) a režim je zvolen
    return !!(oid && rez);
    } catch (e) {
      return false;
    }
  };


  const rezimLocked = getRezimLocked();

  const rezimPrevozu = String(vyjObj?.rezimPrevozu || "").trim() || "PS"; // default PS
  const pitvaTyp = String(vyjObj?.pitvaTyp || "").trim() || "zadna";
  const pojistovnaKod = String(vyjObj?.pojistovnaKod || "").trim();

  const dphMode = String(vyjObj?.dphMode || "").trim(); // "12" | "0" | "custom"
  const dphCustom = String(vyjObj?.dphCustom || "").trim();

  const toNum = (x) => {
    const n = Number(String(x ?? "").replace(",", "."));
    return Number.isFinite(n) ? n : 0;
  };

  const kmPS_total = toNum(vyjObj?.kmPS_total);
  const kmZP_1 = toNum(vyjObj?.kmZP_1);
  const kmZP_2 = toNum(vyjObj?.kmZP_2);

  const kmZP_total = kmZP_1 + kmZP_2;

  const effectiveDphPercent = (() => {
    if (dphMode === "custom") return toNum(dphCustom);
    if (dphMode === "0") return 0;
    if (dphMode === "12") return 12;
    // fallback podle režimu
    return (rezimPrevozu === "ZP") ? 0 : 12;
  })();

  // nastav default DPH podle režimu, jen když ještě není nastaven dphMode
  useEffect(() => {
    try {
      const v = (formData && formData.vyjezdy) ? formData.vyjezdy : {};
      const mode = String(v?.dphMode || "").trim();
      if (!mode) {
        if (rezimPrevozu === "ZP") mergeFormData({ vyjezdy: { ...(v || {}), dphMode: "0" } });
        else mergeFormData({ vyjezdy: { ...(v || {}), dphMode: "12" } });
      }
    } catch {}
  }, [rezimPrevozu, mergeFormData]);

  // helper pro bezpečné uložení do vyjezdy
  const setVyjMeta = useCallback((patchObj) => {
    try {
      const prev = (formDataRef.current && formDataRef.current.vyjezdy) ? formDataRef.current.vyjezdy : {};
      mergeFormData({ vyjezdy: { ...(prev || {}), ...(patchObj || {}) } });
    } catch (e) {
      console.warn("setVyjMeta failed", e);
    }
  }, [mergeFormData]);

  // ==========================
  // /POJISTOVNY_PREVOZ_V1
  // ==========================




  
  // === FIX: držím aktuální formData pro setVyjezdy (bez stale closure) ===
  const formDataRef = useRef(formData);
  useEffect(() => { formDataRef.current = formData; }, [formData]);
  // === /FIX ===

const setVyjezdy = useCallback((k, v) => {
  try {
    // SAFE MERGE: nikdy nepřepisuj celý vyjezdy objekt jen jedním polem
    const prev = (formDataRef.current && formDataRef.current.vyjezdy) ? formDataRef.current.vyjezdy : {};
    const next = { ...(prev || {}), [k]: v };
    mergeFormData({ vyjezdy: next });
  } catch (e) {
    console.warn("setVyjezdy failed", e);
  }
},
    [mergeFormData]
  );

  const handleOhledakFile = useCallback(
    async (e) => {
      const file = e?.target?.files?.[0];
      if (!file) return;

      setOcrError("");
      setOcrOk("");
      setOcrFileName(file.name);
      setOcrBusy(true);

      try {
        const isImage = String(file.type || "").startsWith("image/");
        if (!isImage) throw new Error("OCR teď beru jen fotky (image/*). PDF doplníme později.");

        const fd = new FormData();
        fd.append("file", file);

        const token = getToken() || "";
const r = await fetch(`${API_BASE}/api/ohledak-ocr`, {
          method: "POST",
          headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
          body: fd,
          cache: "no-store",
        });

        if (r.status === 401) {
          authLogout();
          throw new Error("Nepřihlášen – přihlaš se znovu.");
        }

        const text = await safeReadText(r);
        let json = null;
        try {
          json = text ? JSON.parse(text) : null;
        } catch {
          json = null;
        }

        if (!r.ok) throw new Error(json?.error || `OCR selhalo (HTTP ${r.status}).`);

        const extracted = json?.extracted || json || {};

        const jmeno = safeStr(pick(extracted, ["jmeno", "zesnuly.jmeno", "zesnulaOsoba.jmeno"]));
        const prijmeni = safeStr(pick(extracted, ["prijmeni", "zesnuly.prijmeni", "zesnulaOsoba.prijmeni"]));

        const datumUmrti = safeStr(pick(extracted, ["datumUmrti", "zesnuly.datumUmrti", "vstupniInformace.datumUmrti"]));

        const mistoUmrti = safeStr(
          pick(extracted, ["mistoUmrti", "zesnuly.mistoUmrti", "vstupniInformace.mistoUmrti"])
        );

        const adresaUmrti = safeStr(
          pick(extracted, ["adresaUmrti", "zesnuly.adresaUmrti", "vstupniInformace.adresaUmrti"])
        );

        const datumVyjezdu = safeStr(pick(extracted, ["vyjezd.datumVyjezdu", "datumVyjezdu", "vyjezdy.datumVyjezdu"]));
        const casVyjezdu = safeStr(pick(extracted, ["vyjezd.casVyjezdu", "casVyjezdu", "vyjezdy.casVyjezdu"]));

        
        // === AUTO: OCR -> propsani do kontextu (vstupniInformace + zesnulaOsoba) ===
        // Z OCR se snaž vytáhnout i data o zesnulém + úmrtí.
        // Nevadí když to OCR nemá – propsání proběhne jen když něco najdeme a cílová pole jsou prázdná.
        const zesnulyCele = safeStr(
          pick(extracted, [
            "vyjezd.zesnuly",
            "vyjezd.jmenoZesnuleho",
            "vyjezd.jmenoZesnulehoCele",
            "vyjezd.jmenoPrijmeni",
            "zesnuly",
            "jmenoZesnuleho",
            "jmenoZesnulehoCele",
            "jmenoPrijmeni",
            "zesnulyJmenoPrijmeni",
          ])
        );

        const zesParts = String(zesnulyCele || "").trim().split(/\s+/).filter(Boolean);
        const zesJmeno =
          safeStr(pick(extracted, ["vyjezd.jmeno", "jmeno", "zesnulyJmeno"])) || ((Array.isArray(zesParts) ? zesParts[0] : zesParts) || "");
        const zesPrijmeni =
          safeStr(pick(extracted, ["vyjezd.prijmeni", "prijmeni", "zesnulyPrijmeni"])) ||
          (zesParts.length > 1 ? zesParts.slice(1).join(" ") : "");

        const ocrDatumUmrti = safeStr(
          pick(extracted, [
            "vyjezd.ocrDatumUmrti",
            "ocrDatumUmrti",
            "datum_umrti",
            "datumU",
            "vyjezd.datumU",
          ])
        );

        const ocrMistoUmrti = safeStr(
          pick(extracted, ["vyjezd.ocrMistoUmrti", "ocrMistoUmrti", "misto", "vyjezd.misto", "mistoNalezu"])
        );

        const ocrAdresaUmrti = safeStr(
          pick(extracted, ["vyjezd.ocrAdresaUmrti", "ocrAdresaUmrti", "adresa", "vyjezd.adresa", "adresaNalezu"])
        );

        try {
          const z0 = (formData && formData.zesnulaOsoba) ? formData.zesnulaOsoba : {};
          const v0 = (formData && formData.vstupniInformace) ? formData.vstupniInformace : {};

          const zEmpty = !String(z0?.jmeno || "").trim() && !String(z0?.prijmeni || "").trim();
          const vEmpty =
            !String(v0?.datumUmrti || "").trim() &&
            !String(v0?.mistoUmrti || "").trim() &&
            !String(v0?.adresaUmrti || "").trim();

          const payload = {};
          if (zEmpty && (zesJmeno || zesPrijmeni)) {
              payload.zesnulaOsoba = {
                ...(z0 || {}),
                ...(zesJmeno ? { jmeno: zesJmeno } : {}),
                ...(zesPrijmeni ? { prijmeni: zesPrijmeni } : {}),
              };
            }
            if (vEmpty && (ocrDatumUmrti || ocrMistoUmrti || ocrAdresaUmrti)) {
            payload.vstupniInformace = {
              ...(v0 || {}),
              ...(ocrDatumUmrti ? { ocrDatumUmrti } : {}),
              ...(ocrMistoUmrti ? { ocrMistoUmrti } : {}),
              ...(ocrAdresaUmrti ? { ocrAdresaUmrti } : {}),
            };
          }

          if (Object.keys(payload).length && typeof mergeFormData === "function") {
            mergeFormData(payload);
          }
        } catch (e) {}

        // === /AUTO: OCR -> propsani ===
if (datumVyjezdu || casVyjezdu) patch("vyjezdy", { datumVyjezdu, casVyjezdu });

        setOcrOk("✅ OCR hotovo. Zkontroluj pole níže.");
      } catch (err) {
        setOcrError(`Chyba: ${safeStr(err?.message || err)}`);
      } finally {
        setOcrBusy(false);
        try { e.target.value = ""; } catch {}
      }
    },
    [patch]
  );
  const fullName = (() => {
      try {
        const j = safeStr(vyjezdy?.jmeno);
        const p = safeStr(vyjezdy?.prijmeni);
        const fromQuick = [j, p].filter(Boolean).join(" ").trim();

        const fromVyj = safeStr(vyjezdy?.jmenoZesnuleho || vyjezdy?.jmenoZesnulehoCele || vyjezdy?.zesnuly);
        const fromZes = [safeStr(formData?.zesnulaOsoba?.jmeno), safeStr(formData?.zesnulaOsoba?.prijmeni)].filter(Boolean).join(" ").trim();

        return fromQuick || fromVyj || fromZes || "";
      } catch {
        return "";
      }
    })();


  // ===== VYJEZDY_PREVIEW_AND_PICKMETA_v2 =====
  // FIX: VyjezdyForm nemá orderId proměnnou – vezmeme ji z currentOrderId / contextu
  


  const ulozitVyjezdDoZakazky = useCallback(() => {

    // Propsání z Výjezdů do Zakázky:

    // - zesnulaOsoba: jmeno, prijmeni

    // - vstupniInformace: datumUmrti, mistoUmrti, adresaUmrti

    try {

      const vyj = (formData && formData.vyjezdy) ? formData.vyjezdy : {};

  

      const celeJmeno = String(vyj.jmenoZesnuleho || vyj.jmenoZesnulehoCele || vyj.jmeno || vyj.zesnuly || "").trim();

      const parts = String(celeJmeno || "").split(/\s+/).filter(Boolean);

      const jmeno = String(vyj.jmeno || ((Array.isArray(parts) ? parts[0] : parts) || "") || "").trim();

      const prijmeni = String(vyj.prijmeni || (parts.length > 1 ? parts.slice(1).join(" ") : "") || "").trim();

  

      const datumUmrti = String(vyj.datumUmrti || "").trim();

      const mistoUmrti = String(vyj.mistoUmrti || "").trim();

      const adresaUmrti = String(vyj.adresaUmrti || vyj.adresa || "").trim();

  

      // Preferuj mergeFormData (u tebe standard)

      if (typeof mergeFormData === "function") {

        mergeFormData({

          ...(jmeno || prijmeni ? { zesnulaOsoba: { ...(formData?.zesnulaOsoba || {}), ...(jmeno ? { jmeno } : {}), ...(prijmeni ? { prijmeni } : {}) } } : {}),

          ...(datumUmrti || mistoUmrti || adresaUmrti

            ? { vstupniInformace: { ...(formData?.vstupniInformace || {}), ...(datumUmrti ? { datumUmrti } : {}), ...(mistoUmrti ? { mistoUmrti } : {}), ...(adresaUmrti ? { adresaUmrti } : {}) } }

            : {}),

        });

      } else {
        throw new Error("Chybí mergeFormData() – nemám jak propsat data do formuláře.");
      }

      alert("✅ Místo výjezdu + čas převzato z fotky");
    } catch (e) {
      alert("❌ " + String(e?.message || e));
    }
  }, [ctx?.currentOrderId, ctx?.formData?.zakazkaId, ctx?.formData?.id]);  // ===== /VYJEZDY_PREVIEW_AND_PICKMETA_v2 =====


  return (
    <div style={{ maxWidth: 980, margin: "0 auto" }}>
      {/* === VÝJEZDY – modal krok 1 (TEST BUTTON) === */}
      <div className="mb-3 flex flex-wrap gap-2">
        <button
          type="button"
          data-testid="vyjezdy-open-modal1"
          className="px-3 py-2 rounded-xl border"
          onClick={() => {
            setVyjezdyModal1Default({ zdroj: "manual" });
            setVyjezdyModal1Open(true);
          }}
        >
          🧩 Otevřít modal (krok 1)
        </button>
      </div>

      {/* CREATE_ORDER_BTN_VYJEZD_REAL_V2 */}
      <div style={{ marginBottom: 10, display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button
          type="button"
          onClick={async () => {
            try {
              const cid = (ctx?.currentOrderId || ctx?.formData?.zakazkaId || ctx?.formData?.id || "").toString().trim();
              if (cid) { alert("Zakázka už je založená: " + cid); return; }

              // CREATE_GATE_V1: nepustíme CREATE úplně prázdný
              const vyj = ctx?.formData?.vyjezdy || ctx?.formData?.vyjezd || {};
              const vst = ctx?.formData?.vstupniInformace || {};
              const hasAddr = !!(
                (vyj?.mistoUmrti || vyj?.adresaUmrti || vyj?.adresa || "").toString().trim() ||
                (vst?.mistoUmrti || vst?.adresaUmrti || "").toString().trim()
              );
              const hasTime = !!((vyj?.datumVyjezdu || vyj?.datum_vyjezdu || vyj?.casVyjezdu || vyj?.cas_vyjezdu || "").toString().trim());
              const hasFoto = !!(vyj?.fotoMistoVyjezdu || vyj?.foto || vyj?.fotka || null);
              const hasName =
                !!(((ctx?.formData?.zesnulaOsoba?.jmeno || "") + " " + (ctx?.formData?.zesnulaOsoba?.prijmeni || "")).trim()) ||
                !!((ctx?.formData?.zesnuly || "").toString().trim());

              if (!hasFoto && !hasAddr && !hasTime && !hasName) {
                alert("Nejdřív přidej fotku / adresu / čas nebo jméno zesnulého. Pak teprve založíme zakázku.");
                return;
              }

              const payload = {
                stav: "rozpracovana",
                vyjezdy: ctx?.formData?.vyjezdy || ctx?.formData?.vyjezd || {},
                vstupniInformace: ctx?.formData?.vstupniInformace || {},
                zesnulaOsoba: ctx?.formData?.zesnulaOsoba || {},
                vypravitel: ctx?.formData?.vypravitel || {},
              };

                // ✅ založ zakázku přes centralizovaný saveOrder
                if (typeof ctx?.saveOrder !== "function") {
                  alert("❌ Chybí ctx.saveOrder() – nelze založit zakázku bezpečně.");
                  return;
                }

                const out = await ctx.saveOrder();

                const newId = String(out?.orderId || out?.id || out?.data?.orderId || out?.data?.id || out?.item?.id || "").trim();
                if (!newId) { alert("❌ Nevrátilo to ID."); return; }

              try { localStorage.setItem("lastOpenedOrderId", String(newId)); } catch (e2) {}
              if (typeof ctx?.setCurrentOrderId === "function") ctx.setCurrentOrderId(String(newId));
              try { localStorage.setItem("currentOrderId", String(newId)); } catch (e2) {}
              if (typeof ctx?.updateFormData === "function") ctx.updateFormData({
                currentOrderId: String(newId),
                orderId: String(newId),
                zakazkaId: String(newId),
                id: String(newId),
                meta: {
                  ...(((ctx?.formData) && ctx.formData.meta) || {}),
                  id: String(newId),
                  orderId: String(newId),
                  zakazkaId: String(newId),
                },
              });
              else if (typeof ctx?.setFormData === "function") ctx.setFormData((prev) => ({
                ...(prev || {}),
                currentOrderId: String(newId),
                orderId: String(newId),
                zakazkaId: String(newId),
                id: String(newId),
                meta: {
                  ...(((prev || {}).meta) || {}),
                  id: String(newId),
                  orderId: String(newId),
                  zakazkaId: String(newId),
                },
              }));

              alert("✅ Zakázka založena: " + newId);
            } catch (e) {
              console.error("CREATE_ORDER_BTN_VYJEZD_REAL_V2 failed", e);
              alert("❌ Založení zakázky selhalo (detail v konzoli).");
            }
          }}
          style={{
            padding: "10px 12px",
            borderRadius: 10,
            border: "1px solid #ddd",
            fontWeight: 900,
            cursor: "pointer",
            background: "#fff",
          }}
        >
          ➕ Založit zakázku
        </button>
      </div>

      <h2 style={{ marginTop: 0 }}>Výjezdy</h2>

        {/* ==========================
            PREVOZ_REZIM_UI_V1
            ========================== */}
        <div style={{ ...cardStyle, border: "2px solid #111", background: "#fff" }}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
            <div style={{ fontSize: 16, fontWeight: 900 }}>
              🚑 Režim převozu & fakturace
            </div>
            {rezimLocked ? (
              <div style={{ fontSize: 12, fontWeight: 900, padding: "6px 10px", borderRadius: 999, border: "1px solid #ddd", background: "#f6f6f6" }}>
                🔒 Režim je zamčen (zakázka už existuje)
              </div>
            ) : null}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 10 }}>
            <div>
              <div style={labelStyle}>Režim převozu</div>
              <select
                style={inputStyle}
                value={rezimPrevozu}
                disabled={rezimLocked}
                onChange={(e) => {
                  const next = String(e.target.value || "PS");
                  if (rezimLocked) return;
                  setVyjMeta({
                    rezimPrevozu: next,
                    // při změně režimu resetuj pojišťovnu/km ZP aby se nemíchalo
                    ...(next === "ZP" ? {} : { pojistovnaKod: "", kmZP_1: "", kmZP_2: "" }),
                    ...(next === "PS" ? {} : { kmPS_total: "" }),
                    dphMode: (next === "ZP") ? "0" : "12",
                  });
                }}
              >
                <option value="PS">🟥 Komerční převoz (PS) – účtuje se celý výkon</option>
                <option value="ZP">🟩 Převoz hrazený ZP – účtují se jen km s tělem</option>
              </select>
              <div style={{ fontSize: 12, opacity: 0.8, marginTop: 6 }}>
                PS = tam + zpět (komerční). ZP = jen km s tělem (výkon pro pojišťovnu).
              </div>
            </div>

            <div>
              <div style={labelStyle}>Typ pitvy</div>
              <select
                style={inputStyle}
                value={pitvaTyp}
                onChange={(e) => setVyjMeta({ pitvaTyp: String(e.target.value || "zadna") })}
              >
                <option value="zadna">Žádná / běžný převoz</option>
                <option value="zdravotni">Zdravotní pitva</option>
                <option value="soudni">Soudní pitva</option>
              </select>
            </div>
          </div>

          {rezimPrevozu === "ZP" ? (
            <div style={{ marginTop: 12 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                <div>
                  <div style={labelStyle}>Zdravotní pojišťovna zesnulého</div>
                  <select
                    style={inputStyle}
                    value={pojistovnaKod}
                    onChange={(e) => setVyjMeta({ pojistovnaKod: String(e.target.value || "") })}
                  >
                    <option value="">— vyber pojišťovnu —</option>
                    {POJISTOVNY.map(p => (
                      <option key={p.kod} value={p.kod}>{p.nazev}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <div style={labelStyle}>DPH režim (ZP obvykle 0 %)</div>
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    <select
                      style={{ ...inputStyle, flex: 1, minWidth: 220 }}
                      value={dphMode || ((rezimPrevozu === "ZP") ? "0" : "12")}
                      onChange={(e) => setVyjMeta({ dphMode: String(e.target.value || "0") })}
                    >
                      <option value="0">0 %</option>
                      <option value="12">12 %</option>
                      <option value="custom">Vlastní</option>
                    </select>
                    {String(dphMode) === "custom" ? (
                      <input
                        style={{ ...inputStyle, width: 120 }}
                        placeholder="%"
                        value={dphCustom}
                        onChange={(e) => setVyjMeta({ dphCustom: e.target.value })}
                      />
                    ) : null}
                  </div>
                  <div style={{ fontSize: 12, opacity: 0.8, marginTop: 6 }}>
                    Aktuálně: <b>{String(effectiveDphPercent || 0)} %</b>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: 12, borderTop: "1px solid #eee", paddingTop: 12 }}>
                <div style={{ fontWeight: 900, marginBottom: 8 }}>📍 KM (ZP) – jen km s tělem</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
                  <div>
                    <div style={labelStyle}>Jízda 1: místo úmrtí → patologie</div>
                    <input
                      style={inputStyle}
                      inputMode="decimal"
                      placeholder="např. 18.5"
                      value={String(vyjObj?.kmZP_1 ?? "")}
                      onChange={(e) => setVyjMeta({ kmZP_1: e.target.value })}
                    />
                  </div>
                  <div>
                    <div style={labelStyle}>Jízda 2: patologie → místo určení</div>
                    <input
                      style={inputStyle}
                      inputMode="decimal"
                      placeholder="např. 12"
                      value={String(vyjObj?.kmZP_2 ?? "")}
                      onChange={(e) => setVyjMeta({ kmZP_2: e.target.value })}
                    />
                  </div>
                  <div>
                    <div style={labelStyle}>Součet ZP km</div>
                    <input
                      style={{ ...inputStyle, background: "#f6f6f6" }}
                      readOnly
                      value={String(kmZP_total || 0)}
                    />
                  </div>
                </div>
                <div style={{ fontSize: 12, opacity: 0.8, marginTop: 6 }}>
                  Neúčtuje se výjezd prázdného vozu ani návrat prázdného vozu.
                </div>
              </div>
            </div>
          ) : (
            <div style={{ marginTop: 12 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                <div>
                  <div style={labelStyle}>DPH režim (PS obvykle 12 %)</div>
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    <select
                      style={{ ...inputStyle, flex: 1, minWidth: 220 }}
                      value={dphMode || "12"}
                      onChange={(e) => setVyjMeta({ dphMode: String(e.target.value || "12") })}
                    >
                      <option value="12">12 %</option>
                      <option value="0">0 %</option>
                      <option value="custom">Vlastní</option>
                    </select>
                    {String(dphMode) === "custom" ? (
                      <input
                        style={{ ...inputStyle, width: 120 }}
                        placeholder="%"
                        value={dphCustom}
                        onChange={(e) => setVyjMeta({ dphCustom: e.target.value })}
                      />
                    ) : null}
                  </div>
                  <div style={{ fontSize: 12, opacity: 0.8, marginTop: 6 }}>
                    Aktuálně: <b>{String(effectiveDphPercent || 0)} %</b>
                  </div>
                </div>

                <div>
                  <div style={labelStyle}>KM (PS) – celý výkon (tam + zpět)</div>
                  <input
                    style={inputStyle}
                    inputMode="decimal"
                    placeholder="celkem km (tam + zpět)"
                    value={String(vyjObj?.kmPS_total ?? "")}
                    onChange={(e) => setVyjMeta({ kmPS_total: e.target.value })}
                  />
                  <div style={{ fontSize: 12, opacity: 0.8, marginTop: 6 }}>
                    Tohle je komerční režim – km se účtují celé dle ceníku PS.
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* ==========================
            /PREVOZ_REZIM_UI_V1
            ========================== */}


        {/* ===== VYJEZDY_LIST_UI_BLOCK ===== */}
        <div style={{ ...cardStyle, marginTop: 10 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <div style={{ fontSize: 16, fontWeight: 900 }}>
              📋 Seznam výjezdů (backend) — <span style={{ opacity: 0.8 }}>{(vyjezdyList || []).length} ks</span>
            </div>
            <button
              type="button"
              onClick={async () => {
                try { await loadVyjezdyList(); }
                catch (e) { alert("❌ Obnovit selhalo: " + String(e?.message || e)); }
              }}
              style={{ ...btnStyle }}
              title="Načte /api/vyjezdy/list?orderId=..."
            >
              🔄 Obnovit
            </button>
          </div>

          {(vyjezdyList || []).length === 0 ? (
            <div style={{ marginTop: 10, opacity: 0.8 }}>
              Zatím žádné výjezdy.
            </div>
          ) : (
            <div style={{ marginTop: 10, display: "grid", gap: 10 }}>
              {(vyjezdyList || []).map((it, i) => {
                const id = String(it?.id || "");
                const datum = String(it?.datum || "");
                const od = String(it?.casOd || "");
                const doo = String(it?.casDo || "");
                const spz = String(it?.autoSpz || "");
                const km = (it?.km != null ? String(it.km) : "");
                const odkud = String(it?.odkud || "");
                const kam = String(it?.kam || "");
                const pos = Array.isArray(it?.posadka) ? it.posadka.join(", ") : String(it?.posadka || "");

                return (
                  <div key={id || i} style={{ border: "1px solid #ddd", borderRadius: 12, padding: 12 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap" }}>
                      <div style={{ fontWeight: 900 }}>
                        {datum || "—"} {od || ""}{doo ? `–${doo}` : ""}
                      </div>
                      <div style={{ opacity: 0.8, fontSize: 12 }}>
                        {id ? `ID: ${id}` : ""}
                      </div>
                    </div>

                    <div style={{ marginTop: 8, display: "grid", gap: 4, fontSize: 14 }}>
                      <div><b>Auto:</b> {spz || "—"} {km ? `(${km} km)` : ""}</div>
                      <div><b>Posádka:</b> {pos || "—"}</div>
                      <div><b>Trasa:</b> {odkud || "—"} → {kam || "—"}</div>
                      {String(it?.poznamka || "").trim() ? (
                        <div><b>Pozn.:</b> {String(it.poznamka)}</div>
                      ) : null}
                    
                      <div style={{ marginTop: 8, display: "flex", gap: 8, flexWrap: "wrap" }}>
                        <button
                          type="button"
                          style={{ ...btnStyle, padding: "8px 12px" }}
                          onClick={() => applyVyjezdToVstupniInfo(it)}
                          title="Uloží tento výjezd do formData.vyjezdAuto (pro Vstupní informace)"
                        >
                          Použít do Vstupních informací
                        </button>
                      </div>
</div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {/* ===== /VYJEZDY_LIST_UI_BLOCK ===== */}


        {/* AUTO: VYJEZDY_NAME_INPUTS */}
        <div style={cardStyle}>
          <div style={{ fontSize: 16, fontWeight: 900, marginBottom: 10 }}>🧑 Identifikace zesnulého (rychle)</div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <input
              placeholder="Jméno zesnulého"
              value={(formData?.vyjezdy?.jmeno ?? "")}
              onChange={(e) => setVyjezdy("jmeno", e.target.value)}
              style={{ padding: 10, borderRadius: 8, border: "1px solid #ccc", flex: 1, minWidth: 200 }}
            />
            <input
              placeholder="Příjmení zesnulého"
              value={(formData?.vyjezdy?.prijmeni ?? "")}
              onChange={(e) => setVyjezdy("prijmeni", e.target.value)}
              style={{ padding: 10, borderRadius: 8, border: "1px solid #ccc", flex: 1, minWidth: 200 }}
            />
          </div>
        </div>
        {/* /AUTO: VYJEZDY_NAME_INPUTS */}


      <div style={cardStyle}>
        <div style={{ fontSize: 16, fontWeight: 900, marginBottom: 10 }}>📸 Foto výjezdu</div>

        <div style={{ marginBottom: 8, fontWeight: 700 }}>Nahrát fotku (stejně jako ve Foto dokumentaci)</div>

        {/* GALERIE_VYJEZDY_COMPONENT_V1 */}
        <FotogalerieZakazky
          title="Galerie – Ohledací list (bez OCR)"
          scope="ohledaci_list"
          orderId={getEffectiveOrderId()}
          items={formData?.vyjezd?.fotoOhledaciList || []}
          apiFetch={apiFetch}

          ensureOrderId={ensureOrderId}

          onAdd={(uploaded) => {
            const cur = formData?.vyjezd?.fotoOhledaciList || [];
            patch("vyjezd", { fotoOhledaciList: [...cur, ...uploaded] });
          }}
        />

        <FotogalerieZakazky
          title="Galerie – Zesnulý (bez OCR)"
          scope="zesnuly"
          orderId={getEffectiveOrderId()}
          items={formData?.vyjezd?.fotoZesnuly || []}
          apiFetch={apiFetch}

          ensureOrderId={ensureOrderId}

          onAdd={(uploaded) => {
            const cur = formData?.vyjezd?.fotoZesnuly || [];
            patch("vyjezd", { fotoZesnuly: [...cur, ...uploaded] });
          }}
        />
        <input type="file" accept="image/*" onChange={handleOhledakFile} style={{ display: "block", marginBottom: 10 }} />

        {ocrFileName ? (
          <div style={{ fontSize: 13, marginBottom: 8, opacity: 0.9 }}>
            Soubor: <b>{ocrFileName}</b>
          </div>
        ) : null}

        {ocrBusy ? <div style={{ fontWeight: 900 }}>⏳ Načítám z fotky…</div> : null}
        {ocrError ? <div style={{ color: "#d33", fontWeight: 900 }}>{ocrError}</div> : null}
        {ocrOk ? <div style={{ color: "#1a7f37", fontWeight: 900 }}>{ocrOk}</div> : null}

        <div style={{ marginTop: 12 }}>
          <button style={btnStyle} type="button" onClick={() => { setOcrError(""); setOcrOk(""); }}>
              Vyčistit hlášky
                      </button>
        </div>
      </div>

      <div style={cardStyle}>
        <div style={{ fontSize: 16, fontWeight: 900, marginBottom: 10 }}>📝 Údaje výjezdu</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          <div>
            <div style={labelStyle}>Datum výjezdu</div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input
                style={inputStyle}
                type="date"
                id="vyj_modal_datum"
                value={safeStr(vyjezdy.datumVyjezdu)}
                onChange={(e) => setVyjezdy("datumVyjezdu", e.target.value)}
              />
              <button
                type="button"
                style={{ padding: "6px 10px", borderRadius: 8 }}
                onClick={() => _setInputValueById("vyj_modal_datum", _todayISO())}
              >
                Dnes
              </button>
            </div>
          </div>

          <div>
            <div style={labelStyle}>Čas výjezdu</div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input
                style={inputStyle}
                type="time"
                id="vyj_modal_cas_od"
                value={safeStr(vyjezdy.casVyjezdu)}
                onChange={(e) => setVyjezdy("casVyjezdu", e.target.value)}
              />
              <button
                type="button"
                style={{ padding: "6px 10px", borderRadius: 8 }}
                onClick={() => _setInputValueById("vyj_modal_cas_od", _nowHHMM())}
              >
                Teď
              </button>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 10 }}>
          <div style={labelStyle}>Jméno zesnulého (Jméno Příjmení)</div>
          <input
              value={fullName}
              readOnly
              style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ddd", background: "#f6f6f6" }}
              title="Jen náhled – upravuje se nahoře v Identifikaci zesnulého."
            />
          <div style={{ fontSize: 12, opacity: 0.75, marginTop: 6 }}>
            (Bere se ze záložky „Zesnulá osoba“ – OCR to umí vyplnit do kontextu.)
          </div>
        </div>

        <div style={{ marginTop: 10 }}>
          <div style={labelStyle}>Místo úmrtí</div>
          <input
            style={inputStyle}
            value={safeStr(vyjezdyView.mistoUmrti)}
            onChange={(e) => setVyjezdy("mistoUmrti", e.target.value)}
            placeholder="např. Pod Skalkou 525, Český Krumlov"
          />
        </div>

        <div style={{ marginTop: 10 }}>
          <div style={labelStyle}>Datum úmrtí</div>
          <input
            style={inputStyle}
            type="date"
            value={safeStr(vyjezdyView.datumUmrti)}
            onChange={(e) => setVyjezdy("datumUmrti", e.target.value)}
          />
        </div>
      </div>
    
{/* ===== VYJEZDY_PREVIEW_AND_PICKMETA_v2_UI ===== */}
<div style={{ marginTop: 18, borderTop: "1px solid #ddd", paddingTop: 12 }}>
  <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center", marginBottom: 10 }}>
    <div style={{ fontWeight: 900 }}>🖼️ Náhledy fotek ve Výjezdech</div>
    <button
      onClick={() => alert("Galerie zatim neni aktivni")}
      style={{ borderRadius: 12, padding: "10px 12px", border: "1px solid #ddd", fontWeight: 900 }}
      title="Obnoví seznam fotek z /api/foto/list"
    >
      🔄 Obnovit
    </button>
  </div>

  <div style={{ fontWeight: 900, marginBottom: 8 }}>📷 Ohledací list</div>
  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 10 }}>
    {(galOhled || []).map((it) => {
      const oid = oidForVyjezdy();
      const file = it?.file || it?.filename || "";
      const url = oid ? fotoUrl(oid, "ohledaci_list", file) : "";
      return (
        <div key={"ohled_"+file} style={{ border: "1px solid #ddd", borderRadius: 10, padding: 8 }}>
          {url ? <img src={url} alt={file} style={{ width: "100%", height: 110, objectFit: "cover", borderRadius: 8 }} /> : null}
          <div style={{ fontSize: 11, marginTop: 6, wordBreak: "break-word", fontWeight: 900 }}>{file}</div>
          <button
            onClick={() => pickMetaToVyjezd({ ...it, kategorie: "ohledaci_list" })}
            disabled={!oid}
            style={{ marginTop: 8, width: "100%", borderRadius: 12, padding: "10px 12px", border: "1px solid #ddd", fontWeight: 900, opacity: oid ? 1 : 0.6 }}
            title={!oid ? "Otevři zakázku (musí existovat ID)." : "Převezme adresu/GPS a čas z fotky a uloží do zakázky"}
          >
            📍 Převzít adresu + čas z fotky
          </button>
        </div>
      );
    })}
  </div>

  <div style={{ fontWeight: 900, marginTop: 14, marginBottom: 8 }}>📷 Zesnulý</div>
  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 10 }}>
    {(galZesnuly || []).map((it) => {
      const oid = oidForVyjezdy();
      const file = it?.file || it?.filename || "";
      const url = oid ? fotoUrl(oid, "zesnuly", file) : "";
      return (
        <div key={"zesnuly_"+file} style={{ border: "1px solid #ddd", borderRadius: 10, padding: 8 }}>
          {url ? <img src={url} alt={file} style={{ width: "100%", height: 110, objectFit: "cover", borderRadius: 8 }} /> : null}
          <div style={{ fontSize: 11, marginTop: 6, wordBreak: "break-word", fontWeight: 900 }}>{file}</div>
        </div>
      );
    })}
  </div>

  <div style={{ marginTop: 10, fontSize: 12, opacity: 0.85 }}>
    Pozn.: Náhledy používají <code>/api/foto/file</code> s tokenem v query (kvůli iPhonu/IMG).
  </div>
</div>
{/* ===== /VYJEZDY_PREVIEW_AND_PICKMETA_v2_UI ===== */}


      {/* === VÝJEZDY – modal krok 1 (mount) === */}
      <VyjezdyModalKrok1
        open={vyjezdyModal1Open}
        onClose={() => setVyjezdyModal1Open(false)}
        orderId={(ctx?.currentOrderId || formData?.zakazkaId || formData?.id || String(getEffectiveOrderId?.() || "").trim())}
        token={getTokenLS()}
        defaultStep={vyjezdyModal1Default}
        onDone={(r) => {
            try {
              alert("✅ KROK 1 HOTOVO: " + JSON.stringify(r));
            } catch {}

            // === QUICK APPLY (do formData.vyjezdy) ===
            try {
              const field = r?.field || "";
              const ds = r?.defaultStep || {};
              const addr = (ds?.address || ds?.mistoText || ds?.misto || "").toString();
              const gps = ds?.gps || null;

              const prevVyj = (formData?.vyjezdy || formData?.vyjezd || {});
              const nextVyj = { ...prevVyj };

              if (field === "odkud") nextVyj.odkud = addr;
              if (field === "kam") nextVyj.kam = addr;

              // datum/cas zatím necháme na ruční doplnění (krok 2 doděláme potom)
              if (gps) nextVyj.gps = gps;

              const patch = { vyjezdy: nextVyj };

              if (typeof mergeFormData === "function") mergeFormData(patch);
              else if (typeof ctx?.setFormData === "function") ctx.setFormData((prev) => ({ ...(prev||{}), ...patch }));
            } catch (e) {
              try { console.warn("QUICK APPLY failed", e); alert("❌ QUICK APPLY failed: " + String(e?.message||e)); } catch {}
            }
}}
      />

</div>
  );
}
